import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=238db7ab&scoped=true&"
import script from "./NewsPage.vue?vue&type=script&lang=js&"
export * from "./NewsPage.vue?vue&type=script&lang=js&"
import style0 from "./NewsPage.vue?vue&type=style&index=0&id=238db7ab&scoped=true&lang=css&"
import style1 from "./NewsPage.vue?vue&type=style&index=1&id=238db7ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238db7ab",
  null
  
)

export default component.exports